import React from 'react'
import styled from 'styled-components'

import LoginButton from '../../components/Auth/LoginButton'

const LoginMessage = styled.p`
  margin: ${({ theme }) => theme.unit}px 0;
  font-size: 1.1rem;
  font-weight: 600;
`
LoginMessage.displayName = 'LoginMessage'

export default function Login() {
  return (
    <div>
      <LoginMessage>
        This form requires you to login before it can be viewed.
      </LoginMessage>
      <LoginButton />
    </div>
  )
}
